var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { Pencil1Icon } from "@radix-ui/react-icons";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RadixButton } from "../primitives/RadixButton";
import { RadixFlyOut } from "../primitives/RadixFlyOut";
import { RadixInput } from "../primitives/RadixInput";
import { StateCodeComboBox } from "../primitives/StateCodeComboBox";
import { editAddressFlyOutSchema, } from "../editAddressFlyOut/editAddressFlyOutSchema";
import { useAuth, useOrderIntent, useUI } from "../../providers";
import "../addressFlyOut/addressFlyOut.css";
import "./orderAddressDetailsFlyOut.css";
import { SaveIcon } from "../icons";
import { toUspsStateCode } from "../utility/uspsStates";
var toDefaultValues = function (address) { return ({
    address: String((address === null || address === void 0 ? void 0 : address.address) || ""),
    address2: String((address === null || address === void 0 ? void 0 : address.address2) || ""),
    city: String((address === null || address === void 0 ? void 0 : address.city) || ""),
    state: String((address === null || address === void 0 ? void 0 : address.state) || ""),
    zip: String((address === null || address === void 0 ? void 0 : address.zip) || ""),
}); };
var getMapboxAccessToken = function () {
    var session = window.session;
    return String((session === null || session === void 0 ? void 0 : session.mapbox_access_token) ||
        (session === null || session === void 0 ? void 0 : session.mapboxAccessToken) ||
        (session === null || session === void 0 ? void 0 : session.map_box_access_token) ||
        "").trim();
};
var toSuggestion = function (feature) {
    var context = Array.isArray(feature === null || feature === void 0 ? void 0 : feature.context) ? feature.context : [];
    var getContextText = function (idPrefix) {
        var match = context.find(function (entry) {
            return String((entry === null || entry === void 0 ? void 0 : entry.id) || "").startsWith(idPrefix);
        });
        return String((match === null || match === void 0 ? void 0 : match.text) || "").trim();
    };
    var regionEntry = context.find(function (entry) {
        return String((entry === null || entry === void 0 ? void 0 : entry.id) || "").startsWith("region");
    });
    var shortCode = String((regionEntry === null || regionEntry === void 0 ? void 0 : regionEntry.short_code) || "").trim();
    var resolvedStateValue = shortCode.includes("-")
        ? shortCode.split("-")[1]
        : String((regionEntry === null || regionEntry === void 0 ? void 0 : regionEntry.text) || "").trim();
    var state = toUspsStateCode(resolvedStateValue);
    var number = String((feature === null || feature === void 0 ? void 0 : feature.address) || "").trim();
    var street = String((feature === null || feature === void 0 ? void 0 : feature.text) || "").trim();
    return {
        id: String((feature === null || feature === void 0 ? void 0 : feature.id) || "".concat((feature === null || feature === void 0 ? void 0 : feature.place_name) || street)),
        label: String((feature === null || feature === void 0 ? void 0 : feature.place_name) || "").trim(),
        address: [number, street].filter(Boolean).join(" "),
        city: getContextText("place"),
        state: state,
        zip: getContextText("postcode"),
    };
};
var getSessionStoreStateCode = function () {
    var _a, _b;
    var sessionStoreState = (_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.state;
    return toUspsStateCode(sessionStoreState);
};
export var OrderAddressDetailsFlyOut = function (_a) {
    var open = _a.open, onOpenChange = _a.onOpenChange, address = _a.address, _b = _a.previousAddresses, previousAddresses = _b === void 0 ? [] : _b, onApplyAddress = _a.onApplyAddress;
    var updateAddress = useAuth().updateAddress;
    var showToast = useUI().showToast;
    var validateDeliveryAddress = useOrderIntent().validateDeliveryAddress;
    var _c = React.useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = React.useState(null), editingAddressId = _d[0], setEditingAddressId = _d[1];
    var defaultSessionStoreStateCode = React.useMemo(function () { return getSessionStoreStateCode(); }, []);
    var defaultValues = React.useMemo(function () {
        var candidate = toDefaultValues(address);
        if (!candidate.state && defaultSessionStoreStateCode) {
            return __assign(__assign({}, candidate), { state: defaultSessionStoreStateCode });
        }
        return candidate;
    }, [address, defaultSessionStoreStateCode]);
    var normalizedPreviousAddresses = React.useMemo(function () {
        var seen = new Set();
        return previousAddresses
            .filter(function (candidate) {
            return Boolean(candidate);
        })
            .map(function (candidate) { return (__assign({ id: typeof candidate.id === "string" || typeof candidate.id === "number"
                ? candidate.id
                : undefined }, toDefaultValues(candidate))); })
            .filter(function (candidate) {
            if (!candidate.address.trim()) {
                return false;
            }
            var key = [
                candidate.id,
                candidate.address,
                candidate.address2,
                candidate.city,
                candidate.state,
                candidate.zip,
            ]
                .map(function (segment) { return String(segment || "").trim().toLowerCase(); })
                .join("|");
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        });
    }, [previousAddresses]);
    var hasPreviousAddresses = normalizedPreviousAddresses.length > 0;
    var _e = useForm({
        resolver: zodResolver(editAddressFlyOutSchema),
        mode: "onChange",
        defaultValues: defaultValues,
    }), control = _e.control, handleSubmit = _e.handleSubmit, reset = _e.reset, setValue = _e.setValue, watch = _e.watch, _f = _e.formState, errors = _f.errors, isValid = _f.isValid;
    var _g = React.useState([]), suggestions = _g[0], setSuggestions = _g[1];
    var _h = React.useState(false), isFetchingSuggestions = _h[0], setIsFetchingSuggestions = _h[1];
    var _j = React.useState(null), activeSuggestionId = _j[0], setActiveSuggestionId = _j[1];
    var _k = React.useState(""), selectedAddressQuery = _k[0], setSelectedAddressQuery = _k[1];
    var _l = React.useState(!hasPreviousAddresses), showAddressFields = _l[0], setShowAddressFields = _l[1];
    var _m = React.useState(false), isAddressInputFocusedByClick = _m[0], setIsAddressInputFocusedByClick = _m[1];
    var token = React.useMemo(function () { return getMapboxAccessToken(); }, []);
    var addressValue = watch("address") || "";
    var stateValue = watch("state") || "";
    React.useEffect(function () {
        if (open) {
            var selectedAddressId = typeof (address === null || address === void 0 ? void 0 : address.id) === "string" || typeof (address === null || address === void 0 ? void 0 : address.id) === "number"
                ? address.id
                : null;
            reset(defaultValues);
            setSuggestions([]);
            setActiveSuggestionId(null);
            setSelectedAddressQuery("");
            setIsAddressInputFocusedByClick(false);
            setShowAddressFields(!hasPreviousAddresses);
            setEditingAddressId(selectedAddressId);
        }
    }, [address === null || address === void 0 ? void 0 : address.id, defaultValues, hasPreviousAddresses, open, reset]);
    React.useEffect(function () {
        if (!open || !token || !isAddressInputFocusedByClick) {
            setSuggestions([]);
            setIsFetchingSuggestions(false);
            return;
        }
        var query = String(addressValue || "").trim();
        if (query === selectedAddressQuery || query.length < 4) {
            setSuggestions([]);
            setIsFetchingSuggestions(false);
            return;
        }
        var abortController = new AbortController();
        var timeoutId = window.setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
            var params, response, payload, features, _error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsFetchingSuggestions(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        params = new URLSearchParams({
                            access_token: token,
                            autocomplete: "true",
                            country: "US",
                            limit: "5",
                            types: "address",
                        });
                        return [4 /*yield*/, fetch("https://api.mapbox.com/geocoding/v5/mapbox.places/".concat(encodeURIComponent(query), ".json?").concat(params.toString()), { signal: abortController.signal })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("Mapbox autocomplete failed: ".concat(response.status));
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        payload = _a.sent();
                        features = Array.isArray(payload === null || payload === void 0 ? void 0 : payload.features)
                            ? payload.features
                            : [];
                        setSuggestions(features
                            .map(toSuggestion)
                            .filter(function (candidate) { return Boolean(candidate.address); }));
                        return [3 /*break*/, 6];
                    case 4:
                        _error_1 = _a.sent();
                        setSuggestions([]);
                        return [3 /*break*/, 6];
                    case 5:
                        setIsFetchingSuggestions(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); }, 250);
        return function () {
            window.clearTimeout(timeoutId);
            abortController.abort();
        };
    }, [addressValue, isAddressInputFocusedByClick, open, selectedAddressQuery, token]);
    var applySuggestion = function (suggestion) {
        var nextStateValue = String(suggestion.state || "").trim() || String(stateValue || "").trim();
        setValue("address", suggestion.address, {
            shouldValidate: true,
            shouldDirty: true,
        });
        setValue("city", suggestion.city, {
            shouldValidate: true,
            shouldDirty: true,
        });
        setValue("state", nextStateValue, {
            shouldValidate: true,
            shouldDirty: true,
        });
        setValue("zip", suggestion.zip, {
            shouldValidate: true,
            shouldDirty: true,
        });
        setSuggestions([]);
        setActiveSuggestionId(suggestion.id);
        setSelectedAddressQuery(suggestion.address);
    };
    var applyPreviousAddress = function (addressValues) { return __awaiter(void 0, void 0, void 0, function () {
        var validationResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmitting) {
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    return [4 /*yield*/, validateDeliveryAddress(addressValues)];
                case 1:
                    validationResult = _a.sent();
                    if (!validationResult.isValid) {
                        setIsSubmitting(false);
                        showToast(validationResult.message || "It looks like this address is outside our delivery zone. Sorry about that!", "error", true);
                        return [2 /*return*/];
                    }
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, , 4, 5]);
                    return [4 /*yield*/, onApplyAddress(__assign({}, addressValues))];
                case 3:
                    _a.sent();
                    onOpenChange(false);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var startNewAddressEntry = React.useCallback(function () {
        reset({
            address: "",
            address2: "",
            city: "",
            state: defaultSessionStoreStateCode,
            zip: "",
        });
        setSuggestions([]);
        setActiveSuggestionId(null);
        setSelectedAddressQuery("");
        setShowAddressFields(true);
        setEditingAddressId(null);
        setIsAddressInputFocusedByClick(false);
    }, [defaultSessionStoreStateCode, reset]);
    var handleEditPreviousAddress = function (addressValues) {
        var _a;
        reset({
            address: addressValues.address,
            address2: addressValues.address2,
            city: addressValues.city,
            state: addressValues.state,
            zip: addressValues.zip,
        });
        setShowAddressFields(true);
        setEditingAddressId((_a = addressValues.id) !== null && _a !== void 0 ? _a : null);
        setSuggestions([]);
        setActiveSuggestionId(null);
        setSelectedAddressQuery("");
        setIsAddressInputFocusedByClick(false);
    };
    return (React.createElement(RadixFlyOut, { open: open, onOpenChange: onOpenChange, title: "Delivery address details", description: "Confirm your delivery address to continue." },
        React.createElement("form", { className: "address-flyout order-address-details-flyout vertical-checkout-flyout-form", onSubmit: handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
                var validationResult, updated;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, validateDeliveryAddress(values)];
                        case 1:
                            validationResult = _a.sent();
                            if (!validationResult.isValid) {
                                showToast(validationResult.message || "It looks like this address is outside our delivery zone. Sorry about that!", "error", true);
                                return [2 /*return*/];
                            }
                            if (!(editingAddressId !== null && editingAddressId !== undefined)) return [3 /*break*/, 4];
                            setIsSubmitting(true);
                            return [4 /*yield*/, updateAddress({
                                    addressId: editingAddressId,
                                    address: values.address,
                                    address2: values.address2 || "",
                                    city: values.city,
                                    state: values.state,
                                    zip: values.zip,
                                })];
                        case 2:
                            updated = _a.sent();
                            setIsSubmitting(false);
                            if (!updated) {
                                showToast("We couldn't save your address changes. Please try again.", "error");
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, onApplyAddress(__assign(__assign({}, values), { id: editingAddressId }))];
                        case 3:
                            _a.sent();
                            showToast("Address updated.", "success");
                            onOpenChange(false);
                            return [2 /*return*/];
                        case 4: return [4 /*yield*/, onApplyAddress(__assign(__assign({}, values), { id: undefined }))];
                        case 5:
                            _a.sent();
                            onOpenChange(false);
                            return [2 /*return*/];
                    }
                });
            }); }) },
            React.createElement("div", { className: "address-flyout__content" },
                hasPreviousAddresses ? (React.createElement("div", { className: "order-address-details-flyout__saved-addresses", role: "listbox", "aria-label": "Previously used addresses" },
                    React.createElement("p", { className: "order-address-details-flyout__saved-addresses-title" }, "Use a previous address"),
                    normalizedPreviousAddresses.map(function (previousAddress, index) {
                        var lineOne = previousAddress.address;
                        var lineTwo = [
                            previousAddress.city,
                            previousAddress.state,
                            previousAddress.zip,
                        ]
                            .filter(function (segment) { return Boolean(String(segment || "").trim()); })
                            .join(", ");
                        return (React.createElement("div", { key: "".concat(lineOne, "-").concat(lineTwo, "-").concat(index), className: "order-address-details-flyout__saved-address-item-wrap" },
                            React.createElement(RadixButton, { type: "button", className: "order-address-details-flyout__saved-address-item", onClick: function () { return applyPreviousAddress(previousAddress); } },
                                React.createElement("span", { className: "order-address-details-flyout__saved-address-line-one" }, lineOne),
                                lineTwo ? (React.createElement("span", { className: "order-address-details-flyout__saved-address-line-two" }, lineTwo)) : null),
                            React.createElement(RadixButton, { type: "button", className: "order-address-details-flyout__edit-address-button", "aria-label": "Edit ".concat(lineOne), onClick: function () { return handleEditPreviousAddress(previousAddress); } },
                                React.createElement(Pencil1Icon, null))));
                    }),
                    React.createElement(RadixButton, { type: "button", className: "order-address-details-flyout__add-new-address-button", onClick: startNewAddressEntry }, "Add new address"))) : null,
                showAddressFields ? (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "address-flyout__field" },
                        React.createElement("label", { htmlFor: "order-address-details-flyout-address", className: "address-flyout__label" }, "Address"),
                        React.createElement(Controller, { name: "address", control: control, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(RadixInput, { id: "order-address-details-flyout-address", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (event) { return field.onChange(event.target.value); }, onMouseDown: function () {
                                        setIsAddressInputFocusedByClick(true);
                                    }, onBlur: function () {
                                        field.onBlur();
                                        setIsAddressInputFocusedByClick(false);
                                    }, ref: field.ref, "aria-invalid": !!errors.address, "aria-describedby": errors.address
                                        ? "order-address-details-flyout-address-error"
                                        : undefined, autoComplete: "street-address" }));
                            } }),
                        errors.address ? (React.createElement("span", { id: "order-address-details-flyout-address-error", className: "radix-error-message" }, errors.address.message)) : null,
                        token && isAddressInputFocusedByClick ? (React.createElement("div", { className: "address-flyout__suggestions", role: "listbox", "aria-label": "Address suggestions" },
                            isFetchingSuggestions ? (React.createElement("p", { className: "address-flyout__suggestions-status" }, "Looking up address\u2026")) : null,
                            !isFetchingSuggestions &&
                                suggestions.map(function (suggestion) { return (React.createElement(RadixButton, { key: suggestion.id, type: "button", className: [
                                        "address-flyout__suggestion-item",
                                        suggestion.id === activeSuggestionId
                                            ? "address-flyout__suggestion-item--active"
                                            : "",
                                    ]
                                        .filter(Boolean)
                                        .join(" "), onMouseDown: function (event) {
                                        event.preventDefault();
                                    }, onClick: function () { return applySuggestion(suggestion); } }, suggestion.label)); }))) : null),
                    React.createElement("div", { className: "address-flyout__field" },
                        React.createElement("label", { htmlFor: "order-address-details-flyout-address2", className: "address-flyout__label" }, "Address 2"),
                        React.createElement(Controller, { name: "address2", control: control, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(RadixInput, { id: "order-address-details-flyout-address2", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (event) { return field.onChange(event.target.value); }, onBlur: field.onBlur, ref: field.ref, "aria-invalid": !!errors.address2, "aria-describedby": errors.address2
                                        ? "order-address-details-flyout-address2-error"
                                        : undefined, autoComplete: "address-line2" }));
                            } }),
                        errors.address2 ? (React.createElement("span", { id: "order-address-details-flyout-address2-error", className: "radix-error-message" }, errors.address2.message)) : null),
                    React.createElement("div", { className: "address-flyout__field" },
                        React.createElement("label", { htmlFor: "order-address-details-flyout-city", className: "address-flyout__label" }, "City"),
                        React.createElement(Controller, { name: "city", control: control, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(RadixInput, { id: "order-address-details-flyout-city", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (event) { return field.onChange(event.target.value); }, onBlur: field.onBlur, ref: field.ref, "aria-invalid": !!errors.city, "aria-describedby": errors.city
                                        ? "order-address-details-flyout-city-error"
                                        : undefined, autoComplete: "address-level2" }));
                            } }),
                        errors.city ? (React.createElement("span", { id: "order-address-details-flyout-city-error", className: "radix-error-message" }, errors.city.message)) : null),
                    React.createElement("div", { className: "address-flyout__field" },
                        React.createElement("label", { htmlFor: "order-address-details-flyout-state", className: "address-flyout__label" }, "State"),
                        React.createElement(Controller, { name: "state", control: control, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(StateCodeComboBox, { id: "order-address-details-flyout-state", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: field.onChange, onBlur: field.onBlur, ref: field.ref, ariaInvalid: !!errors.state, ariaDescribedBy: errors.state
                                        ? "order-address-details-flyout-state-error"
                                        : undefined, autoComplete: "address-level1" }));
                            } }),
                        errors.state ? (React.createElement("span", { id: "order-address-details-flyout-state-error", className: "radix-error-message" }, errors.state.message)) : null),
                    React.createElement("div", { className: "address-flyout__field" },
                        React.createElement("label", { htmlFor: "order-address-details-flyout-zip", className: "address-flyout__label" }, "ZIP"),
                        React.createElement(Controller, { name: "zip", control: control, render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(RadixInput, { id: "order-address-details-flyout-zip", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (event) { return field.onChange(event.target.value); }, onBlur: field.onBlur, ref: field.ref, "aria-invalid": !!errors.zip, "aria-describedby": errors.zip
                                        ? "order-address-details-flyout-zip-error"
                                        : undefined, autoComplete: "postal-code" }));
                            } }),
                        errors.zip ? (React.createElement("span", { id: "order-address-details-flyout-zip-error", className: "radix-error-message" }, errors.zip.message)) : null))) : null),
            showAddressFields ? (React.createElement("div", { className: "user-account-modal-actions order-address-details-flyout__actions vertical-checkout-flyout-actions" },
                React.createElement(RadixButton, { className: "user-account-inline-button order-address-details-flyout__use-address-button vertical-checkout-flyout-action-button", type: "submit", disabled: !isValid || isSubmitting },
                    editingAddressId ? React.createElement(SaveIcon, null) : null,
                    isSubmitting ? "Saving..." : editingAddressId ? "Save changes" : "Use address"))) : null)));
};
